module.exports = __webpack_public_path__ + "img/15.9cb2160.jpg";